module.exports = __webpack_public_path__ + "static/media/wechat-user-code.250c4269.jpg";